import { Box, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Chart, { useChart } from '../../chart';

const GlobalPatientAttentionChart = ({
    first_time_data,
    follow_up_data,
    double_appointments
}) => {

    console.log(follow_up_data)

    return ( 
        <Box>
            <Typography variant='h5' gutterBottom>
                Atención de consultas
            </Typography>
            <Box>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        {first_time_data &&<AnalyticBarChart 
                            title={"Colaboradores de primera vez"}
                            data={first_time_data}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {follow_up_data &&<AnalyticBarChart 
                            title={"Colaboradores de seguimento"}
                            data={follow_up_data}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {double_appointments &&<AnalyticBarChart 
                            title={"Colaboradores con 2 consultas en el mes"}
                            data={double_appointments}
                        />}
                    </Grid>
                </Grid>
            </Box>
        </Box>
     );
}
 
export default GlobalPatientAttentionChart;

const AnalyticBarChart = ({
    title,
    data,
}) => {

    const chartOptions = useChart({
        //labels: data?.labels??[],
        legend: {
            position:'bottom'
        },
        colors:data?.colors??[],
        plotOptions: {
            bar: {
              borderRadius: 4,
              borderRadiusApplication: 'end',
              horizontal: true,
            }
          },
        dataLabels:{
            enabled:false
        },
        xaxis:{
            categories:data?.labels??[]
        }
        
    })

    return(
        <div>
            <Typography variant='subtitle1' align='center'>
                {title}
            </Typography>
            <Typography variant='body2' align='center'>
                Data de {data.users_count} colabaradores
            </Typography>
            <Box sx={{p:2}}>
                <Box
                    sx={{
                        width:'100%',
                        maxWidth:800,
                        margin:'auto'
                    }}
                    
                >
                    <Chart
                        height={300}
                        type="bar" 
                        series={[{
                            data:data.data
                        }]} 
                        options={chartOptions}
                    />
                </Box>
            </Box>
        </div>
    )
}